import {appRouterPaths} from "services/navigation";
import {WorkProgramsSecondaryPage} from "pages/WorkProgramsSecondary/WorkProgramsSecondary";
import type {AppRouteProps} from "../types";

export const workProgramSecondaryPageRoute: AppRouteProps = {
  path: appRouterPaths.workProgramsSecondary,
  element: <WorkProgramsSecondaryPage/>,
};